import { render, staticRenderFns } from "./defaultchang.vue?vue&type=template&id=6929ab69&scoped=true"
import script from "./defaultchang.vue?vue&type=script&lang=js"
export * from "./defaultchang.vue?vue&type=script&lang=js"
import style0 from "./defaultchang.vue?vue&type=style&index=0&id=6929ab69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6929ab69",
  null
  
)

export default component.exports